import "./App.css";

import { useEffect, useRef } from "react";

import Epk from "./epk";
// import { fadeIn } from "./hooks/useAnimation";
import { inject } from '@vercel/analytics';
import News from './News.js';

import ReactPlayer from "react-player"

// import mfd_title from "./mfd/mfd_title.png";
// import mfd_tracks from "./mfd/mfd_tracks.png";
// // // import Player from "./webamp";

import download_icon from "./download_icon.png";

import PrivacyPolicyMetaAd from "./PrivacyPolicyMetaAd";

inject();

function App() {
  const path = window.location.pathname;

  switch (path) {
    case '/privacy-policy':
      return <PrivacyPolicyMetaAd />;
    default:
      return <RegularContent />;
  }


  // useEffect(() => {
  //   fadeIn(mainRef.current, 0.005);
  // }, []);
}

function RegularContent() {
  const mainRef = useRef();
  const path = window.location.pathname;

  console.log(path)

  useEffect(() => {
    if (path == "/newsletter") document.getElementById("news")?.scrollIntoView();
  }, [path])

  return (
    <main className="font-mavenRegular fade-in main text-center items-center justify-center" ref={mainRef}>
      {/* <div className="flex flex-col justify-center text-center gap-20 pt-16">
        <div className="text-3xl sticky  z-50 text-white">
          badkuzu
        </div>
        <div className="text-3xl absolute text-center text-white">
          <div className="opacity-60 ">badkuzu</div>
        </div>
      </div> */}
      <div className="sticky top-0 p-14 pt-24 pb-24 md:pt-14 md:pb-14 font-mavenSemiBold text-white text-3xl">
        badkuzu
      </div>
      <div className="absolute top-0 w-full opacity-50 p-14 pt-24 md:pt-14 font-mavenSemiBold text-white text-3xl">
        badkuzu
      </div>
      {/* webamp here */}
      {/* <Player /> */}
      {/* mobile version */}
      <div className="md:hidden flex flex-col items-center pt-0 w-full">
        <div style={{ color: 'white' }}>2026 Tour Recap</div>
        <ReactPlayer
          url="https://vimeo.com/1157727854?badge=0&amp;autopause=0&amp;player_id=0&amp;app_id=58479"
          controls
          playing={false}
          width="95%"
          height="250px"
        />
        <div style={{ height: '50px' }}></div>
        <div style={{ color: 'white' }}>ALAA</div>
        <ReactPlayer
          url="https://www.youtube.com/watch?v=xDLhM030FkQ"
          controls
          playing={false}
          width="95%"
          height="250px"
        />
        <div style={{ height: '50px' }}></div>
        <div style={{ color: 'white' }}>Live at ESR Lisbon</div>
        <a href={"https://youtu.be/RMLnRK1WCm8?si=03raD01zX7XM8nO9"} target="_blank" rel="noopener noreferrer">
          <ReactPlayer
            url="https://youtu.be/RMLnRK1WCm8?si=03raD01zX7XM8nO9"
            controls
            playing={false}
            light="/media/esrsnap.png"
            width="94vw"
            height="250px"
          />
        </a>
        <div style={{ height: '50px' }}></div>
        <div style={{ color: 'white' }}>Pomerania LOFT6 session</div>
        <ReactPlayer
          url="https://player.vimeo.com/video/1131684531?badge=0&amp;autopause=0&amp;player_id=0&amp;app_id=58479"
          controls
          playing={false}
          width="95%"
          height="250px"
        />
        <div style={{ height: '50px' }}></div>
        <div style={{ color: 'white' }}>Implosion LOFT6 session</div>
        <ReactPlayer
          url="https://player.vimeo.com/video/1128706898?badge=0&amp;autopause=0&amp;player_id=0&amp;app_id=58479"
          controls
          playing={false}
          width="95%"
          height="250px"
        />
        <div style={{ height: '20px' }}></div>
        <div style={{ color: 'white' }}>Live set promo cut</div>
        <ReactPlayer
          url="https://player.vimeo.com/video/1123017370?badge=0&amp;autopause=0&amp;player_id=0&amp;app_id=58479"
          controls
          playing={false}
          width="95%"
          height="250px"
        />
        <div style={{ height: '70px' }}></div>
        <div style={{ color: 'white' }}>PODCASTS</div>
        <br />
        <ReactPlayer
          url="https://api.soundcloud.com/playlists/1917898859&color=%23000000&auto_play=false&hide_related=false&show_comments=true&show_user=true&show_reposts=false&show_teaser=false&visual=true"
          width="95%"
          height="500px"
        />
        <div style={{ height: '70px' }}></div>
        <div style={{ color: 'white' }}>LIVE / DJ SET</div>
        <br />
        <ReactPlayer
          url="https://soundcloud.com/badkuzu/sets/liveanddj"
          width="95%"
          height="500px"
        />
      </div>
      {/* desktop version */}
      <div className="hidden md:flex flex-col gap-2 items-center pt-10 w-full">
        <div style={{ color: 'white' }}>2026 Tour Recap</div>
        <br /><br />
        <ReactPlayer
          url="https://vimeo.com/1157727854?badge=0&amp;autopause=0&amp;player_id=0&amp;app_id=58479"
          controls
          playing={false}
        />
        <div style={{ height: '50px' }}></div>
        <div style={{ color: 'white' }}>ALAA</div>
        <br /><br />
        <ReactPlayer
          url="https://www.youtube.com/watch?v=xDLhM030FkQ"
          controls
          playing={false}
        />
        <div style={{ height: '50px' }}></div>
        <div style={{ color: 'white' }}>Live at ESR Lisbon</div>
        <br /><br />
        <a href={"https://youtu.be/RMLnRK1WCm8?si=03raD01zX7XM8nO9"} target="_blank" rel="noopener noreferrer">
          <ReactPlayer
            url="https://youtu.be/RMLnRK1WCm8?si=03raD01zX7XM8nO9"
            controls
            playing={false}
            light="/media/esrsnap.png"
          />
        </a>
        <div style={{ height: '50px' }}></div>
        <div style={{ color: 'white' }}>Pomerania LOFT6 session</div>
        <br /><br />
        <ReactPlayer
          url="https://player.vimeo.com/video/1131684531?badge=0&amp;autopause=0&amp;player_id=0&amp;app_id=58479"
          controls
          playing={false}
        />
        <div style={{ height: '50px' }}></div>
        <div style={{ color: 'white' }}>Implosion LOFT6 session</div>
        <br /><br />
        <ReactPlayer
          url="https://player.vimeo.com/video/1128706898?badge=0&amp;autopause=0&amp;player_id=0&amp;app_id=58479"
          controls
          playing={false}
        />
        <div style={{ height: '50px' }}></div>
        <div style={{ color: 'white' }}>Live set promo cut</div>
        <br /><br />
        <ReactPlayer
          url="https://player.vimeo.com/video/1123017370?badge=0&amp;autopause=0&amp;player_id=0&amp;app_id=58479"
          controls
          playing={false}
        />
        <div style={{ height: '50px' }}></div>
        <div style={{ color: 'white' }}>PODCASTS</div>
        <br /><br />
        <ReactPlayer
          url="https://api.soundcloud.com/playlists/1917898859&color=%23000000&auto_play=false&hide_related=false&show_comments=true&show_user=true&show_reposts=false&show_teaser=false&visual=true"
        />
        <div style={{ height: '50px' }}></div>
        <div style={{ color: 'white' }}>LIVE / DJ SET</div>
        <br /><br />
        <ReactPlayer
          url="https://soundcloud.com/badkuzu/sets/liveanddj"
        />
      </div>

      <br></br><br/><br></br><br/>

      <div style={{ color: 'white' }}>
        <h1 className="text-3xl text-bold">Past Shows</h1>

        <br/><br/>

        <p><strong>2026</strong></p>
        <div><strong>08.01</strong> – W Sercu, Poznań, PL</div>
        <div><strong>09.01</strong> – Klub Szalonych, Wrocław, PL</div>
        <div><strong>10.01</strong> – Studio DB, Berlin, DE</div>
        <div><strong>15.01</strong> – Expreso33, Barcelona, ES</div>
        <div><strong>16.01</strong> – Sankofa, Valencia, ES</div>

        <br />

        <p><strong>2025</strong></p>
        <div><strong>01.12</strong> – ESR Live, Lisbon, PT</div>
        <div><strong>KitKat Club</strong>, Berlin, DE <em>(DJ set)</em></div>

        <br />

        <p><strong>2024</strong></p>
        <div><strong>Artistania</strong> <em>(Audiovisual live)</em></div>

        <br />

        <p><strong>2023</strong></p>
        <div><strong>Cassette Heads Sessions</strong> <em>(Live + band)</em></div>
        <div><strong>Christa Kupfer</strong>, Berlin, DE <em>(Live)</em></div>

        <br />

        <p><strong>2022</strong></p>
        <div><strong>badkuzu's 3.0</strong> @ Artistania, Berlin, DE <em>(Live)</em></div>
        <div><strong>Bucht der Träumer</strong> <em>(Live)</em></div>

        <br></br>
      </div>

      <div className="flex flex-col gap-2 items-center pt-20">
        <a href="https://www.dropbox.com/scl/fo/coxdv61kpk8j7r4jgzh2b/AO4dDtA-Zj_pVAH_Frvg3Tc?rlkey=ujp2hc1zudh9jz7h01fahbl3e&st=y950wexb&dl=0" target="_blank" style={{ filter: "hue-rotate(340deg)", color: "white" }} className="w-2/3 md:w-1/5 lg:w-1/6 p-2 pb-4">
          <img src={download_icon} className="saturate-0 contrast-300 brightness-80" />
          <div className="text-white text-xl lg:text-3xl font-extrabold">DOWNLOAD<br /> <div className="text-sm lg:text-xl ">ELECTRONIC PRESS KIT, RIDER, PHOTOS etc.</div></div>
        </a>
      </div>
      <br /><br /><br />
      {/* <Epk /> */}
      {/* <div id="news"><News /></div> */}
      <br /><br /><br />
      <div className="text-white">©℗ badkuzu</div>
      <div className="background" />
      <br />
      <div style={{ height: "100px", position: "relative" }}></div>
      <div className="sticky flex gap-5 items-center justify-center bottom-0 bg-white p-3 px-5" style={{ zIndex: "1000" }}>
        <a href="https://instagram.com/_badkuzu" target="_blank"><img src="media/igicon.png" className="w-11" /></a>
        <a href="https://soundcloud.com/badkuzu" target="_blank"><img src="media/soundcloud_logo_bw.png" className="w-14" /></a>
        <a href="https://badkuzu.bandcamp.com" target="_blank"><img src="media/bandcamp.png" className="w-14" /></a>
        <a href="https://www.dropbox.com/scl/fo/coxdv61kpk8j7r4jgzh2b/AO4dDtA-Zj_pVAH_Frvg3Tc?rlkey=ujp2hc1zudh9jz7h01fahbl3e&st=y950wexb&dl=0" target="_blank" className="text-2xl"><b>EPK</b></a>
        <a href="mailto:badkuzu@gmail.com" className="text-sm md:text-lg" style={{ cursor: "pointer" }}>badkuzu@gmail.com</a>
      </div>
    </main>
  );
}

export default App;
